<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar tiempo de ciclo ideal</h5>
          <button type="button" @click="closeModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
        </div>
        <div v-if="isLoading" style="padding: 5ch 0">
          <SpeenComponent
              :isAutomatic="true"
              :ringWidth="14"
              :spinnerSize="15"
              :isverticalAligned="true"
          />
        </div>
        <div class="modal-body" v-else>
          <form @submit.prevent="saveReference">
            <div class="form-group">
              <label for="edit-code-input">Tiempo de ciclo ideal (b/m):</label>
              <input v-model="form.ideal_cycle_time" id="edit-ideal-cycle-time-input" required class="form-control" ref="firstInput" type="number" min="1"/>
            </div>
            <hr>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-secondary me-2" @click="closeModal">Cancelar</button>
              <button type="submit" class="btn btn-danger">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
  name: 'ReferenceEditModal',
  components: {
    SpeenComponent
  },
  props: {
    referenceExtPk: { type: String, required: true }
  },
  data() {
    return {
      form: {
        ext_pk: null,
        ideal_cycle_time: 0,
      },
      isLoading: true
    };
  },
  methods: {
    loadReference() {
      this.isLoading = true;
      axios.get(`/api/reference/${this.referenceExtPk}`)
        .then(response => {
          const data = response.data;
          this.form = {
            ext_pk: data.ext_pk || null,
            ideal_cycle_time: data.ideal_cycle_time || 0,
          };
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateReference() {
      this.isLoading = true;
      axios.patch(`/api/reference/ideal-cycle-time`, this.form)
        .then(() => {
          showCustomSuccessSweetAlert('Tiempo de ciclo ideal editado correctamente');
          this.$emit('refresh-list');
          this.closeModal();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    saveReference() {
      Swal.fire({
        title: '¿Desea guardar los cambios?',
        text: '¡Está acción afectará a los cálculos de tiempo de las órdenes activas y en cola relacionadas con este artículo!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: 'red',
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateReference();
        }
      });
    },
    closeModal() {
      this.$emit('close-modal');
    },
  },
  mounted(){
    this.loadReference();
  }
};
</script>
